module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEQAAABEBAMAAADKPY6BAAAAFVBMVEUAAABmmf9Ygv9agf9Zgv9Ygv9Ygf4XPsKuAAAABnRSTlMACpOU5uo5Ah5aAAAAWUlEQVRIx2NgIBkwqgYJEFDCnJZmQEAJS1qaAwElbGlpCaNKRpWMKhmsShhN0vACZwEGpjQCQIGBlZCSAGKUEGEREc4djelRJaNKhq4SIpoVRDROiGjiYAEAlZuSob+sDrsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/knowledge/add.png
// module id = Bbot
// module chunks = 1